import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import BlockCard from '../../components/BlockCard/BlockCard';

import BookingCalendar from '../../components/BookingCalendar/BookingCalendar';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    // pdTop: {
    //     paddingTop: '30px',
    // }
}));

export default function Dahboard() {

    const classes = useStyles();

    return (
        <div
            className={classes.root}
            title="Default Dashboard"
            >
           
            {/* <Grid
                className={classes.container}
                container
                spacing={3}
            >
                <Grid
                    item
                    lg={3}
                    sm={6}
                    xs={12}
                >
                    <BlockCard />
                </Grid>

                <Grid
                    item
                    lg={3}
                    sm={6}
                    xs={12}
                >
                    <BlockCard />
                </Grid>

                <Grid
                    item
                    lg={3}
                    sm={6}
                    xs={12}
                >
                    <BlockCard />
                </Grid>

                <Grid
                    item
                    lg={3}
                    sm={6}
                    xs={12}
                >
                    <BlockCard />
                </Grid>
               
               
               
               
            </Grid> */}

            <div className={classes.pdTop}>
                <BookingCalendar/>
            </div>
            
        </div>
    )
}
